import React from "react"
import { StyledAdminPanel } from "@/components/Catalog/AdminPanel/StyledAdminPanel"
import { useAuth } from "@/hooks/auth"
import { useAppSelector } from "@/hooks/redux"
import { Button } from "@/ui/Button/Button"
import { ROUTES } from "@/utils/constants"

export const AdminPanelCategory = () => {
  const { isAuth, user } = useAuth()
  const { id = "" } = useAppSelector(
    ({ catalog }) => catalog.currentCategory ?? {},
  )

  if (!isAuth) {
    return null
  }

  if (!user?.isAdmin) {
    return null
  }

  return (
    <StyledAdminPanel>
      <Button
        variant={"small"}
        as={"a"}
        href={`${ROUTES.dashboard}/catalog/categories/${id}`}
      >
        Редактировать
      </Button>
    </StyledAdminPanel>
  )
}
